/**
 * Cookie Blocking対策のWebStorageスタブ
 */
export default class DummyStorage implements Storage {
    private keys: string[] = [];
    private values: any[] = [];

    public get length(): number {
        return this.keys.length;
    }

    public key(index: number): string {
        return this.keys[index];
    }

    public getItem(key: string): string | null {
        const i = this.keys.indexOf(key);
        if (i < 0) {
            return null;
        }
        return this.values[i];
    }

    public setItem(key: string, value: string): void {
        const i = this.keys.indexOf(key);
        if (i < 0) {
            this.keys.push(key);
            this.values.push(value);
        } else {
            this.values[i] = value;
        }
    }

    public removeItem(key: string): void {
        const i = this.keys.indexOf(key);
        if (i < 0) {
            return;
        }
        this.keys.splice(i, 1);
        this.values.splice(i, 1);
    }

    public clear(): void {
        this.keys = [];
        this.values = [];
    }
}
